import React, {useState} from 'react'
import { useDispatch } from 'react-redux'
import { deleteAddress } from '../../redux/actions/addressAction'
import Modal from '../util/Modal'

const DeleteAddress = ({id}) => {

    const dispatch = useDispatch()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)

    const handleSubmit = () => {
        setLoading(true)
        dispatch(deleteAddress(id))    
        .then(res=>{
            if (!res.success) {
                setError(res.message)
            } else {
                setLoading(false)
                closeModal()
            }
        })
    }

    const closeModal = () => {
        document.getElementById("closeDeleteAddressModal").click()
    }

  return (
    <Modal targetName={"deleteAddressModal"}>
        <div className="row p-0 p-lg-5">
            <div className="col-12">
            <h4 className='text-center'>Delete Address</h4>
            <p className='text-center'>Are you sure you want to delete this address?</p>
            </div>
            <div className="col-12 col-md-6">
                <button className='btn btn-block btn-lg btn-outline-dark' onClick={closeModal}>Cancel</button>
            </div>
            <div className="col-12 col-md-6">
                <button className='btn btn-block btn-lg btn-danger' onClick={handleSubmit}>{loading ? <div className="spinner-border loader-sizing" style={{height:"1.5rem", width:"1.5rem"}} role="status"><span className="sr-only"></span></div>:"Delete"}</button>
            </div>
        </div>
        <button className='d-none' data-dismiss="modal" id='closeDeleteAddressModal'>Close Modal</button>
    </Modal>
  )
}

export default DeleteAddress